module.exports = __webpack_public_path__ + "img/fique-tranquilo-estamos-aqui-para-ajuda-lo.bb11b518.svg";